<template>
  <div class="landing-page">
    <div class="container-fluid">
      <div class="row lastnews">
        <div class="col-12">
          <div class="container">
            <div class="row lastnews-content" v-if="lastNews.length > 0">
              <div class="col-lg-8 col-12 main-new">
                <div class="news-content">
                  <b>Notícias</b>
                  <div class="news-title">
                    <router-link
                      :to="{
                        name: 'public.view-news',
                        params: { id: mainNew.id },
                      }"
                      >{{ mainNew.title }}</router-link
                    >
                  </div>
                  <div class="news-info">
                    <div class="share">
                      <i class="fa fa-share-alt" aria-hidden="true"></i>
                      {{ mainNew.number_clicks }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-12 news-list">
                <div
                  v-for="(item, index) in lastNews"
                  v-bind:key="index"
                  class="news-item"
                  v-bind:class="{ inactive: index > 0 }"
                >
                  <div class="close-new w-100 d-flex justify-content-end">
                    <i
                      v-on:click="deleteNews(index)"
                      class="fa fa-times"
                      aria-hidden="true"
                    ></i>
                  </div>
                  <hr />
                  <div class="content-new">
                    <router-link
                      :to="{
                        name: 'public.view-news',
                        params: { id: item.id },
                      }"
                      >{{ item.title }}</router-link
                    >
                  </div>
                  <div class="info-new">
                    <i class="fa fa-share-alt" aria-hidden="true"></i>
                    {{ item.number_clicks }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container landingpage-content">
      <div class="row">
        <div class="col-lg-4 col-12 governet-list-item">
          <div class="title-list">Destaques</div>
          <div class="banner-list featured"></div>
          <div class="items-list">
            <router-link
              v-for="item in mainNews"
              v-bind:key="item.id"
              class="primary-a"
              :to="{ name: 'public.view-news', params: { id: item.id } }"
            >
              <div class="item">
                <b>{{ item.title }}</b>
              </div>
            </router-link>
          </div>
        </div>
        <div class="col-lg-4 col-12 governet-list-item">
          <div class="title-list">Artigos mais lidos</div>
          <div class="banner-list articles"></div>
          <div class="items-list">
            <router-link
              v-for="item in articlesNews"
              v-bind:key="item.id"
              class="primary-a"
              :to="{ name: 'client.read-text', params: { text_id: item.id } }"
            >
              <div class="item">
                <b>{{ item.title }}</b>
                <div class="authors">
                  <span
                    v-for="(author, index) in item.authors"
                    v-bind:key="author.id"
                    >{{
                      author.name +
                      (index == item.authors.length - 1 ? "" : ", ")
                    }}</span
                  >
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="col-lg-4 col-12 governet-magazines">
          <div class="content">
            <div class="title">Revistas Online</div>
            <div class="container-fluid">
              <div class="row magazines">
                <div
                  class="col-lg-6 col-12 magazine-edition"
                  v-for="magazine in magazines"
                  v-bind:key="magazine.id"
                >
                  <router-link
                    class="primary-a"
                    :to="{
                      name: 'public.magazine-editions',
                      params: { id: magazine.id },
                    }"
                  >
                    <img :src="magazine.cover_url" alt />
                    <div class="name">{{ magazine.name }}</div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-12 governet-banner">
          <router-link class="primary-a" :to="{ name: 'public.products' }">
            <img src="@/assets/landing_page/banner-1.png" alt />
          </router-link>
        </div>
        <div class="col-lg-4 col-12 governet-banner">
          <router-link class="primary-a" :to="{ name: 'public.collaborator' }">
            <img src="@/assets/landing_page/banner-2.png" alt />
          </router-link>
        </div>
        <div class="col-lg-4 col-12 governet-banner">
          <router-link class="primary-a" :to="{ name: 'public.promotional' }">
            <img src="@/assets/landing_page/banner-3.png" alt />
          </router-link>
        </div>
      </div>
      <div class="row legislation">
        <div class="col-12 legislation-label">
          <div class="double-border d-flex w-100">
            <div class="red-border"></div>
            <div class="gray-border"></div>
          </div>
          <div class="title">Legislação especializada</div>
        </div>
        <div
          v-for="(item, index) in legislations"
          v-bind:key="index"
          class="col-lg-4 col-12"
        >
          <div class="legislation-card">
            <router-link
              class="primary-a"
              :to="{ name: 'client.read-text', params: { text_id: item.id } }"
            >
              <div class="red-border"></div>
              <div class="title-legislation">{{ item.title }}</div>
              <div class="description-legislation">
                {{ limitText(item.ementa, 140) }}
              </div>
              <div class="legislation-footer">
                <div class="image-footer d-flex align-items-center">
                  <img src="@/assets/landing_page/logo_g.png" alt />
                  <b>Governet</b>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div id="center-banner" v-if="showBanner">
      <img :src="centerBanner" alt  />
      <div class="close-banner" v-on:click="showBanner = false">
        <i class="fa fa-times" aria-hidden="true"></i>
      </div>
    </div>
  </div>
</template>
<script src="//code.jivosite.com/widget.js" jv-id="v9cJG5paDz" async></script>

<script>
import axios from "axios";
import helper from "@/imports/Helpers";

export default {
  name: "landing-page",
  data() {
    return {
      perPage: 4,
      showBanner: false,
      perPageMainNews: 6,
      currentPageNews: 1,
      rowsNews: 0,
      mainNew: {},
      mainNews: [],
      currentPageMainNews: 1,
      rowsMainNews: 0,
      rowsArticles: 0,
      articlesNews: [],
      currentPageArticles: 1,
      magazines: [],
      rowsLegislation: 0,
      legislations: [],
      lastNews: [],
      centerBanner: "",
    };
  },
  mounted() {
    this.mainNew = this.lastNews[0];
    this.getLastNews();
    this.getMainNews();
    this.getArticles();
    this.getLegislations();
    this.getMagazines();
    this.getCenterBanner();
  },
  watch: {
    lastNews: function () {
      if (this.lastNews.length > 0) {
        this.mainNew = this.lastNews[0];
      } else {
        this.currentPageNews++;
        if (this.currentPageNews * this.perPage > this.rowsNews) {
          this.currentPageNews = 1;
        }
        this.getLastNews();
      }
    },
  },
  methods: {
    limitString: function (text, length) {
      return text.substring(0, length) + "...";
    },
    deleteNews: function (index) {
      this.lastNews.splice(index, 1);
    },
    getLastNews: function () {
      axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/news_public?page[number]=${this.currentPageNews}&page[size]=${this.perPage}&sort=-id&filter[highlighted]=0`
        )
        .then((response) => {
          this.rowsNews = response.data.total;
          this.lastNews = response.data.data;
        });
    },
    getMainNews: function () {
      axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/news_public?page[number]=${this.currentPageNews}&page[size]=${this.perPageMainNews}&sort=-id&filter[highlighted]=1`
        )
        .then((response) => {
          this.rowsMainNews = response.data.total;
          this.mainNews = response.data.data;
        });
    },
    getLegislations: function () {
      axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/texts_public?page[number]=${this.currentPageArticles}&page[size]=3&sort=-id&filter[indice_id]=4`
        )
        .then((response) => {
          this.rowsLegislation = response.data.total;
          this.legislations = response.data.data;
        });
    },
    getCenterBanner: function () {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/getCenterBanner`)
        .then((response) => {
          this.centerBanner = response.data.file_url
          console.log(this.centerBanner)
          if(this.centerBanner == undefined){
            this.showBanner = false;
          }
          else{
            this.showBanner = true;
          }
        });
    },
    getMagazines: function () {
      axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/magazines_public?page[number]=1&page[size]=50`
        )
        .then((response) => {
          this.magazines = response.data.data;
        });
    },
    getArticles: function () {
      axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/texts_public?include=authors&page[number]=${this.currentPageArticles}&page[size]=${this.perPage}&sort=-access_count&filter[indice_id]=1`
        )
        .then((response) => {
          this.rowsArticles = response.data.total;
          this.articlesNews = response.data.data;
        });
    },
    limitText: function (text, limit) {
      return helper.limitText(text, limit);
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/client/LandingPage.scss";
</style>